import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationKey } from '../../types/modulesInterfaces';

interface TranslationParams {
    [key: string]: string
}

export interface TranslatableTextProps {
    translationKey: TranslationKey,
    style?: React.CSSProperties,
    className?: string
    translationParams?: TranslationParams | {},
    paramsComponents?: React.ReactNode[],
    prefix?: string,
    suffix?: string,
    showTooltip?: boolean,
}

const TranslatableText = ({
    translationKey,
    translationParams,
    style,
    className,
    paramsComponents,
    prefix,
    suffix,
    showTooltip = false,
}: TranslatableTextProps) => {
    const { t } = useTranslation();
    const tooltip = t(translationKey, translationParams);

    return (
        <span style={style} className={className} title={showTooltip ? tooltip : undefined}>
            {prefix}
            <Trans i18nKey={translationKey as any} values={translationParams} tOptions={{ interpolation: { escapeValue: translationParams ? false : true } }} components={paramsComponents ?? [<></>] as any} />
            {suffix}
        </span>
    )
}

export default TranslatableText
